import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {
  detailsFormGroup: UntypedFormGroup;
  cardTitle: string;

  @Input('formGroup')
  set detailsFg(value: any) {
    this.detailsFormGroup = value;
  }

  @Input('title')
  set cardTitleName(value: any) {
    this.cardTitle = value;
  }

  constructor() { }

  ngOnInit() {
  }

}
